import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Dropdown, Checkbox } from 'semantic-ui-react';

import LanguageService from '../../services/languageService';
import useSelectItem from './use_select_item';

import './index.css'

const languageService = new LanguageService;

function useDidUpdateEffect(fn, inputs) {
  const isMountingRef = useRef(false);

  useEffect(() => {
    isMountingRef.current = true;
  }, []);

  useEffect(() => {
    if (!isMountingRef.current) {
      return fn();
    } else {
      isMountingRef.current = false;
    }
  }, inputs);
}

function DropdownItems(props) {
  const {itemClassName, onClickItem, options, selectedItems } = props;

  const getItemClassName = (value) => {
    return selectedItems.includes(value) ? `${itemClassName} active` : itemClassName;
  }

  return (
    <React.Fragment>
      {
        options.map((item)=>{
          return <Dropdown.Item
                  className={getItemClassName(item.value)}
                  onClick={onClickItem}
                  key={item.key}
                  value={item.value}
                  >
                  <Checkbox checked={selectedItems.includes(item.value)} label={item.text}/>
                </Dropdown.Item>
        })
      }
    </React.Fragment>
  )
}

function getValuesFromOptions(options) {
  return options.map(option => option.value);
}

function FilterByTagsDropdown(props) {
  const { translations, resetFilters } = props;
  const riskTagOptions = languageService.translateRiskTagOptions(translations);
  const riskTagOptionsValues = getValuesFromOptions(riskTagOptions);
  const controlTagOptions = languageService.translateControlTagOptions(translations);
  const controlTagOptionsValues = getValuesFromOptions(controlTagOptions);
  const concatenatedTagOptions = riskTagOptions.concat(controlTagOptions);

  const [selectedRiskTags, selectRiskTag, filterSelectedRiskTags, resetSelectedRiskTags] = useSelectItem({ defaultValue: [], validItems: riskTagOptionsValues });
  const [selectedControlTags, selectControlTag, filterSelectedControlTags, resetSelectedControlTags] = useSelectItem({ defaultValue: [], validItems: controlTagOptionsValues  });
  const selectedTags = selectedRiskTags.concat(selectedControlTags)

  const onRemoveItem = (evt, data) => {
    filterSelectedRiskTags(evt, data);
    filterSelectedControlTags(evt, data);
  }

  useDidUpdateEffect(()=>{
    props.onChange({ riskTagsFilter: selectedRiskTags, controlTagsFilter: selectedControlTags })
  }, [selectedRiskTags, selectedControlTags])

  useEffect(()=>{
    if (resetFilters) {
      resetSelectedRiskTags([])
      resetSelectedControlTags([])
    }
  }, [resetFilters])

  return (
    <Dropdown
      id="filter-by-tags-dropdown"
      className="filter-by-tags-dropdown"
      placeholder={props.placeholder}
      options={concatenatedTagOptions}
      value={selectedTags}
      onChange={onRemoveItem}
      onFocus={props.onFocus}
      fluid
      multiple
      search
      selection
      closeOnBlur
      closeOnChange
    >
      <Dropdown.Menu>
        <div>
          <Dropdown.Header>Risk Tags</Dropdown.Header>
          <DropdownItems
            itemClassName="risk-tag-option"
            onClickItem={selectRiskTag}
            options={riskTagOptions}
            selectedItems={selectedRiskTags}
          />
        </div>
        <div>
          <Dropdown.Header>Control Tags</Dropdown.Header>
          <DropdownItems
            itemClassName="control-tag-option"
            onClickItem={selectControlTag}
            options={controlTagOptions}
            selectedItems={selectedControlTags}
          />
        </div>
      </Dropdown.Menu>
    </Dropdown>
  )
}

const mapStateToProps = (state) => {
  return {
    translations: state.language.language.translations,
  }
}

export default connect(mapStateToProps, {})(FilterByTagsDropdown);


// WEBPACK FOOTER //
// ./src/views/project_control_register/filter_by_tags_dropdown.js